import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ActionBar from './actionbar';

import I18n from '@module/i18n';
import Button from '@component/form/element/button';
import UIActions from '@app/action/ui';

export const UploadInProgressWarning = ({
  setUploadInProgressWarningVisibility,
  showUploadInProgressWarning,
  action,
}) => {
  if (!showUploadInProgressWarning) return null;

  return (
    <ActionBar text={I18n.t('notification.refresh_transfer_upload_lost')}>
      <Button
        type="actionbar-action"
        text={I18n.t('alert.confirm_refresh_transfer_upload_lost')}
        onClick={(event) => {
          action(event);
          setUploadInProgressWarningVisibility(false);
        }}
      />
      <Button
        type="actionbar-cancel"
        text={I18n.t('alert.cancel_refresh_transfer_upload_lost')}
        onClick={() => setUploadInProgressWarningVisibility(false)}
      />
    </ActionBar>
  );
};

UploadInProgressWarning.propTypes = {
  action: PropTypes.func.isRequired,
  setUploadInProgressWarningVisibility: PropTypes.func.isRequired,
  showUploadInProgressWarning: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ ui }) => ({
  showUploadInProgressWarning: ui.showUploadInProgressWarning,
});

const mapDispatchToProps = {
  setUploadInProgressWarningVisibility:
    UIActions.setUploadInProgressWarningVisibility,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadInProgressWarning);
